const fromUrl = async (url, name, type = 'application/pdf') => {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Falha ao carregar o arquivo: ${response.statusText}`)
  }

  const blob = await response.blob()

  return new File([blob], name, { type: blob.type || type })
}

export default fromUrl
